<template>
    <u-card-border-top v-bind="$attrs">
        <template v-if="innerClass || cardInnerSize">
            <div class="card-inner" :class="[innerClass, cardInnerSize]">
                <slot />
            </div>
        </template>
        <template v-else>
            <slot />
        </template>
    </u-card-border-top>
</template>

<script>
import UCardBorderTop from "@/components/publish/styles/cards/u-card-border-top.vue";

export default {
    props: {
        innerClass: { type: String, default: "" },
        cardInnerSize: { type: String, default: "" },
    },
    components: {
        UCardBorderTop,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
